import styles from "./MailLogs.module.css";
import MailLogCard from "./MailLogCard";
import useMailLogs from "../../hooks/use-mail-logs";
// @ts-expect-error pure js
import useLoader from "../../hooks/use-loader.js";
import Text from "../UI/Text";

const HISTORY_CUTOFF_DATE = "2026-07-01";

interface MailLogsProps {
  tenantId?: number;
  tenantDebut?: string;
}

export default function MailLogs({ tenantId, tenantDebut }: MailLogsProps) {
  const { mailLogs, retrySending, cancelMail, sendNow, isLoading } =
    useMailLogs({ tenantId });

  const tenantArrivedBeforeCutoff =
    tenantDebut !== undefined && tenantDebut < HISTORY_CUTOFF_DATE;

  const [retrying, retrySendingHandler] = useLoader(async function (
    id: number,
  ) {
    try {
      await retrySending(id);
    } catch (error) {
      console.error(error);
    }
  });

  const [cancelling, cancelMailHandler] = useLoader(async function (
    id: number,
  ) {
    try {
      await cancelMail(id);
    } catch (error) {
      console.error(error);
    }
  });

  const [sending, sendNowHandler] = useLoader(async function (id: number) {
    try {
      await sendNow(id);
    } catch (error) {
      console.error(error);
    }
  });

  if (!isLoading && mailLogs.length === 0) {
    return (
      <div className={styles.empty}>
        <Text color="muted">Aucun e-mail envoyé pour le moment.</Text>
        {tenantArrivedBeforeCutoff && (
          <Text variant="deci" color="muted">
            L'historique des e-mails envoyés avant le 01/07/2026 n'est pas
            conservé ici.
          </Text>
        )}
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {mailLogs.map((mail) => (
        <MailLogCard
          key={mail.id}
          mail={mail}
          onRetry={retrySendingHandler}
          onCancel={cancelMailHandler}
          onSendNow={sendNowHandler}
          isRetrying={retrying}
          isCancelling={cancelling}
          isSending={sending}
        />
      ))}
    </div>
  );
}
